export const MIDDLEWARE_API = {
  pdfGenerator: {
    base: '/pdf-generator',
    prescription: '/prescription-base64',
    labReq: '/lab-req-base64',
    combinePdfs: '/combine-pdfs',
    extractPdfPages: '/extract-pdf-pages',
    getPdfPageCount: '/get-pdf-page-count'
  }
};
